import _extends from "@babel/runtime/helpers/esm/extends";
import { ComponentSize } from '../../declarations/common.decl';
export var TextFieldVariants;

(function (TextFieldVariants) {
  TextFieldVariants["INPUT"] = "input";
  TextFieldVariants["LIST"] = "list";
})(TextFieldVariants || (TextFieldVariants = {}));

export var TextFieldInputSize = _extends({
  X_SMALL: 'xSmall'
}, ComponentSize);